import $ from 'jquery';
import globalScope from 'core/globalScope';

/**
 * On supprime les param�tres provenance des URLs des d�tails d'offres pour les offres recommand�es (optimisation SEO)
 Lorsque l'internaute clique sur le lien d'une offre recommand�e,
 on fait un appel AJAX au back pour stocker l'ID de l'offre et sa provenance dans le FlashScope, puis le lien nous emm�ne vers le d�tail de l'offre (sans le param provenance dans l'URL).
 Lors de l'affichage du d�tail de l'offre reco, si dans le FlashScope on r�cup�re une provenance pour l'ID de l'offre en question,
 on la met dans le formulaire postuler.
 Si l'internaute candidate, le param�tre "provenance" du formulaire est donc soumis
 et on envoie � FCA un �v�nement de candidature, dans lequel on va ajouter � la main au "referer"
 (URL source de l'action, ici le d�tail de l'offre) le param�tre provenance=xxxx avec la valeur soumise
 dans le formulaire de candidature.
 De plus, pour p�r�niser la solution, on va ajouter un param�tre "provenance" au JSON envoy� � FCA
 pour qu'� terme on n'ai plus besoin de "trafiquer" le referer comme actuellement.
 */
export default function () {
  $('.js-tracking-detail-offre-reco').click(function (e) {
    e.preventDefault();
    const offreId = $(this).attr('data-offreId'),
      provenance = $(this).attr('data-provenance'),
      href = $(this).attr('href'),
      target = $(this).attr('target');
    if (offreId !== '' && provenance !== '') {
      $.ajax({
        type: 'POST',
        url: '/emploi/publi/track_detail_offre_reco',
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify({
          offreId: offreId,
          provenance: provenance
        })
      })
        .done(_ => {
          if (target === '_blank')
            globalScope.window.open(href, '_blank');
          else
            globalScope.window.location = href;
        });
    }
  });
}
